import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CircleLoader } from "react-spinners";
import {
  brandViewAllRequest,
  brandViewByAlcoholIdRequest,
} from "../../../redux/brands/BrandAction";
import {
  productQuantityAddRequest,
  productQuantityEditRequest,
  productQuantityResetState,
  productQuantityViewAllRequest,
} from "../../../redux/productQuantity/ProductQuantityAction";
import {
  productSearchViewAllRequest,
  productViewByBrandIdRequest,
} from "../../../redux/products/ProductAction";
import { alcoholSearchViewAllRequest } from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomButton from "../../constant/commonButton";
import CustomDataGrid from "../../constant/commondatagrid";
import ReusableFormFields from "../../constant/reusableFormFields";
import CommonSnackbar from "../../notification/Snackbar";
import Pagination from "../../constant/CommonPagenation";
import { useEffect, useState } from "react";
import { filterStyles, styles } from "../../components/LoginStyles";

const ProductQuantity = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [brandToDelete, setBrandToDelete] = useState(null);
  const [editBrand, setEditBrand] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [emptyList, setEmptyList] = useState([]);
  const [brandMessage, setBrandMessage] = useState("");
  const [productMessage, setProductMessage] = useState("");
  //search
  const [searchQuery, setSearchQuery] = useState("");

  const {
    register,
    handleSubmit,
    formState,
    control,
    setValue,
    setError,
    reset,
    watch,
  } = useForm();
  const { errors } = formState;

  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const addProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.addProductQuantity
  );

  const preprocessData = (data) => {
    if (!data) return [];
    if (!Array?.isArray(data)) data = [data];

    const uniqueIds = new Set();
    return data
      .map((item) => {
        if (uniqueIds.has(item?.id)) return null;
        uniqueIds.add(item?.id);

        return {
          id: item?.id,
          AlocolId: item?.type_of_alcohol_id,
          AlcoholName: item?.ProductAlcoholType?.alcohol_type || "",
          BrandId: item?.brand_id,
          BrandName: item?.Brand?.brand_name || "",
          ProductId: item?.product_id,
          ProductName: item?.Product?.product_name || "",
          WholesalerId: item?.wholesaler_id || "",
          WholesalerName: item?.WholeSaler?.wholesaler_name || "",
          TypeOfQuantity: item?.type_of_quantity || "",
          Measurements: item?.measurements || "",
          Status: item?.status || "",
          CreatedAt: item?.created_at || "",
          UpdatedAt: item?.updated_dt || "",
        };
      })
      .filter((item) => item !== null);
  };

  const editProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.editProductQuantity
  );

  const viewAllProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.viewAllProductQuantities || {}
  );
  const productQuantityList = viewAllProductQuantitiesState?.data?.data || [];
  const totalRecords = viewAllProductQuantitiesState?.data?.totalRecords || 0;

  const productQuantitiesPageSize =
    viewAllProductQuantitiesState?.pageSize || 10;

  // Alcohol Type State
  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllSearchAlcohols || {}
  );
  const AlcoholList = typeOfAlcoholState?.data?.data || [];

  // Brand State
  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewBrandsByAlcoholId
  );
  const brandList = brandViewAllState?.data?.data || [];
  const selectedAlcoholId = watch("type_of_alcohol_id");

  // Product State
  const productViewAllState = useSelector(
    (state) => state?.product?.viewProductsByBrandId || {}
  );
  const productList = productViewAllState?.data?.data || [];
  const selectedBrandId = watch("brand_id");

  // Dynamic Options
  const dynamicAlcoholOptions = AlcoholList?.map((TypeAlcohol) => ({
    value: TypeAlcohol?.id,
    label: TypeAlcohol?.alcohol_type,
  }));

  const dynamicBrandOptions = brandList?.map((brand) => ({
    value: brand?.id,
    label: brand?.brand_name,
  }));

  const dynamicProductOptions = productList?.map((product) => ({
    value: product?.id,
    label: product?.product_name,
  }));

  // Handle Change Functions
  const handleAlcoholChange = (event) => {
    const selectedAlcoholId = event.target.value;
    setValue("type_of_alcohol_id", selectedAlcoholId);

    if (selectedAlcoholId) {
      dispatch(brandViewByAlcoholIdRequest(selectedAlcoholId));
    }

    setValue("brand_id", "");
    setValue("product_id", "");

    setBrandMessage("");
    setProductMessage("");
  };

  const handleBrandChange = (event) => {
    const selectedBrandId = event.target.value;
    setValue("brand_id", selectedBrandId);

    if (selectedBrandId) {
      dispatch(productViewByBrandIdRequest(selectedBrandId));
    }

    setValue("product_id", "");

    setProductMessage("");
  };

  // Filter Functions
  const filterBrands = () => {
    if (!selectedAlcoholId) return;

    if (dynamicBrandOptions.length === 0) {
      setBrandMessage("⚠ No brands available for the selected alcohol type.");
    } else {
      setBrandMessage("");
    }
  };

  const filterProducts = () => {
    if (!selectedBrandId) return;

    if (dynamicProductOptions.length === 0) {
      setProductMessage("⚠ No sub brand available for the selected brand.");
    } else {
      setProductMessage("");
    }
  };

  useEffect(() => {
    filterBrands();
    filterProducts();
  }, [dynamicBrandOptions, dynamicProductOptions]);

  // const inputFields = (ProductOptions) => [
  //   {
  //     name: "type_of_alcohol_id",
  //     label: "Type Of Alcohol",
  //     type: "searchable-select",
  //     options: dynamicAlcoholOptions,
  //     size: "selectMedium",
  //     rules: { required: "Type Of Alcohol is required" },
  //     onChange: handleAlcoholChange,
  //   },
  //   {
  //     name: "brand_id",
  //     label: "Brand Name",
  //     type: "searchable-select",
  //     size: "selectMedium",
  //     options: [
  //       ...dynamicBrandOptions,
  //       {
  //         value: "",
  //         label: brandMessage ? (
  //           <span style={styles.capacityWarning}>{brandMessage}</span>
  //         ) : (
  //           ""
  //         ),
  //         isDisabled: true,
  //       },
  //     ],
  //     rules: { required: "Brand Name is required" },
  //     onChange: handleBrandChange,
  //   },
  //   {
  //     name: "product_id",
  //     label: "Sub Brand Name",
  //     type: "searchable-select",
  //     size: "selectMedium",
  //     options: [
  //       ...dynamicProductOptions,
  //       {
  //         value: "",
  //         label: productMessage ? (
  //           <span style={styles.capacityWarning}>{productMessage}</span>
  //         ) : null,
  //         isDisabled: true,
  //       },
  //     ],
  //     rules: {
  //       required: "Sub Brand Name is required",
  //     },
  //   },
  //   {
  //     name: "measurements",
  //     label: "Select Measurement Unit",
  //     type: "select",
  //     options: [
  //       { value: "ML", label: "ML" },
  //       { value: "L", label: "L" },
  //     ],
  //   },
  //   {
  //     name: "type_of_quantity",
  //     label: "Quantity",
  //     rules: {
  //       required: "Quantity is required",
  //       pattern: {
  //         value: /^[0-9]+$/,
  //         message: "Only numbers are allowed",
  //       },
  //       validate: (value) => {
  //         const selectedMeasurement = watch("measurements");
  //         const numericValue = Number(value);
  //         const selectedAlcoholName = AlcoholList.find(
  //           (item) => item.id === watch("type_of_alcohol_id")
  //         )?.alcohol_type?.toLowerCase?.();

  //         if (!selectedMeasurement) return "Measurement is required";

  //         if (!numericValue || numericValue <= 0)
  //           return "Quantity must be a positive number";

  //         if (selectedAlcoholName?.toLowerCase?.().includes("beer")) {
  //           if (selectedMeasurement === "ML") {
  //             if (numericValue < 330 || numericValue > 750) {
  //               return "For Beer (ML), quantity must be between 330 and 750";
  //             }
  //           } else if (selectedMeasurement === "L") {
  //             if (numericValue !== 1) {
  //               return "For Beer (L), quantity must be exactly 1";
  //             }
  //           }
  //         } else {
  //           if (selectedMeasurement === "ML") {
  //             if (numericValue < 750 || numericValue > 999) {
  //               return "For 'ML', quantity must be between 750 and 999";
  //             }
  //           } else if (selectedMeasurement === "L") {
  //             if (numericValue < 1 || numericValue > 5) {
  //               return "For 'L', quantity must be between 1 and 5";
  //             }
  //           }
  //         }

  //         return true;
  //       },
  //     },
  //   },
  // ];

  const inputFields = (ProductOptions) => {
    const selectedAlcoholId = watch("type_of_alcohol_id");
    const selectedAlcoholName = AlcoholList.find(
      (item) => item.id === selectedAlcoholId
    )?.alcohol_type?.toLowerCase?.();

    const isBeer = selectedAlcoholName?.includes("beer");

    const measurementOptions = isBeer
      ? [{ value: "PINT", label: "PINT" }]
      : [
          { value: "ML", label: "ML" },
          { value: "L", label: "L" },
        ];

    return [
      {
        name: "type_of_alcohol_id",
        label: "Type Of Alcohol",
        type: "searchable-select",
        options: dynamicAlcoholOptions,
        size: "selectMedium",
        rules: { required: "Type Of Alcohol is required" },
        onChange: handleAlcoholChange,
      },
      {
        name: "brand_id",
        label: "Brand Name",
        type: "searchable-select",
        size: "selectMedium",
        options: [
          ...dynamicBrandOptions,
          {
            value: "",
            label: brandMessage ? (
              <span style={styles.capacityWarning}>{brandMessage}</span>
            ) : (
              ""
            ),
            isDisabled: true,
          },
        ],
        rules: { required: "Brand Name is required" },
        onChange: handleBrandChange,
      },
      {
        name: "product_id",
        label: "Sub Brand Name",
        type: "searchable-select",
        size: "selectMedium",
        options: [
          ...dynamicProductOptions,
          {
            value: "",
            label: productMessage ? (
              <span style={styles.capacityWarning}>{productMessage}</span>
            ) : null,
            isDisabled: true,
          },
        ],
        rules: {
          required: "Sub Brand Name is required",
        },
      },
      {
        name: "measurements",
        label: "Select Measurement Unit",
        type: "select",
        options: measurementOptions,
        rules: { required: "Measurement is required" },
      },
      {
        name: "type_of_quantity",
        label: "Quantity",
        rules: {
          required: "Quantity is required",
          pattern: {
            value: /^[0-9]+$/,
            message: "Only numbers are allowed",
          },
          validate: (value) => {
            const selectedMeasurement = watch("measurements");
            const numericValue = Number(value);
            const selectedAlcohol = AlcoholList.find(
              (item) => item.id === watch("type_of_alcohol_id")
            );
            const selectedAlcoholName =
              selectedAlcohol?.alcohol_type?.toLowerCase?.();
            const isBeer = selectedAlcoholName?.includes("beer");

            if (!selectedMeasurement) return "Measurement is required";
            if (!numericValue || numericValue <= 0)
              return "Quantity must be a positive number";

            if (isBeer) {
              if (selectedMeasurement !== "PINT") {
                return "Beer must be measured in Pints only.";
              }
              if (numericValue < 1 || numericValue > 500) {
                return "Beer quantity must be between 1 and 500 Pints.";
              }
            } else {
              if (selectedMeasurement === "ML") {
                if (numericValue < 750 || numericValue > 999) {
                  return "For 'ML', quantity must be between 750 and 999";
                }
              } else if (selectedMeasurement === "L") {
                if (numericValue < 1 || numericValue > 5) {
                  return "For 'L', quantity must be between 1 and 5";
                }
              }
            }

            return true;
          },
        },
      },
    ];
  };

  const columns = (handleDeleteRow) => [
    {
      field: "AlcoholName",
      headerName: "Alcohol Type",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Alcohol Type",
    },
    {
      field: "BrandName",
      headerName: "Brand Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Brand Name",
    },
    {
      field: "ProductName",
      headerName: "Sub Brand Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Sub Brand Name",
    },
    // {
    //   field: "TypeOfQuantity",
    //   headerName: "Quantity",
    //   width: getColumnWidth("column"),
    //   renderCell: (params) => params.value || "Unknown Quantity",
    // },
    // {
    //   field: "Measurements",
    //   headerName: "Measurement Unit",
    //   width: getColumnWidth("column"),
    //   renderCell: (params) => {
    //     if (!params?.value) return "N/A";
    //     return params?.value === "ML" ? "ML" : "L";
    //   },
    // },
    {
      field: "QuantityWithUnit",
      headerName: "Quantity (Unit)",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        const quantity = params.row?.TypeOfQuantity;
        const unit = params.row?.Measurements;

        if (!quantity || !unit) return "N/A";

        const isPlural = Number(quantity) > 1;
        let formattedUnit = unit;

        if (unit === "PINT") {
          formattedUnit = isPlural ? "PINTS" : "PINT";
        }

        return `${quantity} ${formattedUnit}`;
      },
    },
    {
      field: "Status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params?.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("column1"),
      renderCell: (params) => (
        <Box display="flex" gap="10px" mt={3}>
          <CustomButton
            variant="contained"
            buttonStyle="SubmitButton"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => {
              reset();
              setEditBrand(params?.row);
              setOpenEditDialog(true);

              dispatch(alcoholSearchViewAllRequest());

              setValue("type_of_alcohol_id", params?.row?.AlocolId);
              setValue("brand_id", params?.row?.BrandId);
              setValue("product_id", params?.row?.ProductId);
              setValue("type_of_quantity", params?.row?.TypeOfQuantity);
              setValue("status", params?.row?.Status);
              setValue("wholesaler_id", params?.row?.WholesalerId);
              setValue("measurements", params?.row?.Measurements);

              if (params?.row?.AlocolId) {
                dispatch(brandViewByAlcoholIdRequest(params?.row?.AlocolId));
              }
              if (params?.row?.BrandId) {
                dispatch(productViewByBrandIdRequest(params?.row?.BrandId));
              }
            }}
          >
            Edit
          </CustomButton>
        </Box>
      ),
    },
  ];

  // const inputField = (wholesalerOptions, ProductOptions) => [
  //   {
  //     name: "type_of_alcohol_id",
  //     label: "Type Of Alcohol",
  //     type: "searchable-select",
  //     options: dynamicAlcoholOptions,
  //     size: "selectMedium",
  //     rules: { required: "Type Of Alcohol is required" },
  //     onChange: handleAlcoholChange,
  //   },
  //   {
  //     name: "brand_id",
  //     label: "Brand Name",
  //     type: "searchable-select",
  //     size: "selectMedium",
  //     options: [
  //       ...dynamicBrandOptions,
  //       {
  //         value: "",
  //         label: brandMessage ? (
  //           <span style={styles.capacityWarning}>{brandMessage}</span>
  //         ) : (
  //           ""
  //         ),
  //         isDisabled: true,
  //       },
  //     ],
  //     rules: { required: "Brand Name is required" },
  //     onChange: handleBrandChange,
  //   },
  //   {
  //     name: "product_id",
  //     label: "Sub Brand Name",
  //     type: "searchable-select",
  //     size: "selectMedium",
  //     options: [
  //       ...dynamicProductOptions,
  //       {
  //         value: "",
  //         label: productMessage ? (
  //           <span style={styles.capacityWarning}>{productMessage}</span>
  //         ) : null,
  //         isDisabled: true,
  //       },
  //     ],
  //     rules: {
  //       required: "Product Name is required",
  //     },
  //   },
  //   {
  //     name: "measurements",
  //     label: "Select Measurement Unit",
  //     type: "select",
  //     options: [
  //       { value: "ML", label: "ML" },
  //       { value: "L", label: "L" },
  //     ],
  //   },
  //   {
  //     name: "type_of_quantity",
  //     label: "Quantity",
  //     rules: {
  //       required: "Quantity is required",
  //       pattern: {
  //         value: /^[0-9]+$/,
  //         message: "Only numbers are allowed",
  //       },
  //       validate: (value) => {
  //         const selectedMeasurement = watch("measurements");
  //         const numericValue = Number(value);
  //         const selectedAlcoholName = AlcoholList.find(
  //           (item) => item.id === watch("type_of_alcohol_id")
  //         )?.alcohol_type?.toLowerCase?.();

  //         if (!selectedMeasurement) return "Measurement is required";

  //         if (!numericValue || numericValue <= 0)
  //           return "Quantity must be a positive number";

  //         if (selectedAlcoholName?.toLowerCase?.().includes("beer")) {
  //           if (selectedMeasurement === "ML") {
  //             if (numericValue < 330 || numericValue > 750) {
  //               return "For Beer (ML), quantity must be between 330 and 750";
  //             }
  //           } else if (selectedMeasurement === "L") {
  //             if (numericValue !== 1) {
  //               return "For Beer (L), quantity must be exactly 1";
  //             }
  //           }
  //         } else {
  //           if (selectedMeasurement === "ML") {
  //             if (numericValue < 750 || numericValue > 999) {
  //               return "For 'ML', quantity must be between 750 and 999";
  //             }
  //           } else if (selectedMeasurement === "L") {
  //             if (numericValue < 1 || numericValue > 5) {
  //               return "For 'L', quantity must be between 1 and 5";
  //             }
  //           }
  //         }

  //         return true;
  //       },
  //     },
  //   },
  //   {
  //     name: "status",
  //     label: "Status",
  //     type: "select",
  //     options: [
  //       { value: 1, label: "Active" },
  //       { value: 2, label: "Inactive" },
  //     ],
  //     rules: { required: "Status is required" },
  //   },
  // ];

  const inputField = (wholesalerOptions, ProductOptions) => {
    const selectedAlcoholId = watch("type_of_alcohol_id");
    const selectedAlcoholName = AlcoholList.find(
      (item) => item.id === selectedAlcoholId
    )?.alcohol_type?.toLowerCase?.();
    const isBeer = selectedAlcoholName?.includes("beer");

    const measurementOptions = isBeer
      ? [{ value: "PINT", label: "PINT" }]
      : [
          { value: "ML", label: "ML" },
          { value: "L", label: "L" },
        ];

    return [
      {
        name: "type_of_alcohol_id",
        label: "Type Of Alcohol",
        type: "searchable-select",
        options: dynamicAlcoholOptions,
        size: "selectMedium",
        rules: { required: "Type Of Alcohol is required" },
        onChange: handleAlcoholChange,
      },
      {
        name: "brand_id",
        label: "Brand Name",
        type: "searchable-select",
        size: "selectMedium",
        options: [
          ...dynamicBrandOptions,
          {
            value: "",
            label: brandMessage ? (
              <span style={styles.capacityWarning}>{brandMessage}</span>
            ) : (
              ""
            ),
            isDisabled: true,
          },
        ],
        rules: { required: "Brand Name is required" },
        onChange: handleBrandChange,
      },
      {
        name: "product_id",
        label: "Sub Brand Name",
        type: "searchable-select",
        size: "selectMedium",
        options: [
          ...dynamicProductOptions,
          {
            value: "",
            label: productMessage ? (
              <span style={styles.capacityWarning}>{productMessage}</span>
            ) : null,
            isDisabled: true,
          },
        ],
        rules: {
          required: "Product Name is required",
        },
      },
      {
        name: "measurements",
        label: "Select Measurement Unit",
        type: "select",
        options: measurementOptions,
        rules: { required: "Measurement is required" },
      },
      {
        name: "type_of_quantity",
        label: "Quantity",
        rules: {
          required: "Quantity is required",
          pattern: {
            value: /^[0-9]+$/,
            message: "Only numbers are allowed",
          },
          validate: (value) => {
            const selectedMeasurement = watch("measurements");
            const numericValue = Number(value);

            if (!selectedMeasurement) return "Measurement is required";
            if (!numericValue || numericValue <= 0)
              return "Quantity must be a positive number";

            if (isBeer) {
              if (selectedMeasurement !== "PINT") {
                return "Beer must be measured in Pints only.";
              }
              if (numericValue < 1 || numericValue > 500) {
                return "Beer quantity must be between 1 and 500 Pints.";
              }
            } else {
              if (selectedMeasurement === "ML") {
                if (numericValue < 750 || numericValue > 999) {
                  return "For 'ML', quantity must be between 750 and 999";
                }
              } else if (selectedMeasurement === "L") {
                if (numericValue < 1 || numericValue > 5) {
                  return "For 'L', quantity must be between 1 and 5";
                }
              }
            }

            return true;
          },
        },
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: [
          { value: 1, label: "Active" },
          { value: 2, label: "Inactive" },
        ],
        rules: { required: "Status is required" },
      },
    ];
  };

  const getProductQuantityListPayload = (pageNo, pageSize, searchKey = "") => ({
    pageNo,
    pagesize: pageSize,
    pagination_required: true,
    search_key: searchKey.trim(),
  });

  useEffect(() => {
    const page = currentPage || 1;
    const search = (searchQuery || "").trim();

    const timer = setTimeout(() => {
      dispatch(
        productQuantityViewAllRequest(
          getProductQuantityListPayload(page, productQuantitiesPageSize, search)
        )
      );
    }, 500);

    return () => clearTimeout(timer);
  }, [currentPage, searchQuery, dispatch, productQuantitiesPageSize]);

  // OPTIMIZED: Process data when product quantity state changes
  useEffect(() => {
    if (viewAllProductQuantitiesState?.success) {
      const processed = preprocessData(productQuantityList);
      setRows(processed);
    } else {
      setRows(emptyList);
    }
  }, [viewAllProductQuantitiesState, productQuantityList]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setBrandToDelete(id);
    setOpenAddDialog(true);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handelAddBrand = () => {
    dispatch(alcoholSearchViewAllRequest());

    reset({
      type_of_alcohol_id: "",
      brand_id: "",
      type_of_quantity: "",
      product_id: "",
      measurements: "",
      wholesaler_id: "",
    });
    setOpenAddDialog(true);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Alcohol Type Asc":
        sortedRows.sort((a, b) => a.AlcoholName?.localeCompare(b?.AlcoholName));
        break;
      case "Sort by Alcohol Type Desc":
        sortedRows.sort((a, b) => b.AlcoholName?.localeCompare(a?.AlcoholName));
        break;
      case "Sort by Brand Name Asc":
        sortedRows.sort((a, b) => a.BrandName?.localeCompare(b?.BrandName));
        break;
      case "Sort by Brand Name Desc":
        sortedRows.sort((a, b) => b.BrandName?.localeCompare(a?.BrandName));
        break;
      case "Sort by Product Name Asc":
        sortedRows.sort((a, b) => a.ProductName?.localeCompare(b?.ProductName));
        break;
      case "Sort by Product Name Desc":
        sortedRows.sort((a, b) => b.ProductName?.localeCompare(a?.ProductName));
        break;
      case "Sort by Type of Quantity Asc":
        sortedRows.sort((a, b) =>
          a.TypeOfQuantity?.localeCompare(b?.TypeOfQuantity)
        );
        break;
      case "Sort by Type of Quantity Desc":
        sortedRows.sort((a, b) =>
          b.TypeOfQuantity?.localeCompare(a?.TypeOfQuantity)
        );
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  useEffect(() => {
    if (addProductQuantitiesState?.success) {
      setSnackbarMessage("Product Quantity added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      reset({
        type_of_alcohol_id: "",
        brand_id: "",
        type_of_quantity: "",
        product_id: "",
        measurements: "",
        wholesaler_id: "",
      });
      setSearchQuery("");
      setOpenAddDialog(false);
      dispatch(productQuantityResetState());
      dispatch(
        productQuantityViewAllRequest(
          getProductQuantityListPayload(
            currentPage,
            productQuantitiesPageSize,
            searchQuery
          )
        )
      );
    } else if (addProductQuantitiesState?.error) {
      const errorFields = addProductQuantitiesState?.errormessage || {};

      if (typeof errorFields === "string") {
        setError("type_of_quantity", {
          type: "manual",
          message: errorFields,
        });
      } else if (typeof errorFields === "string") {
        setError("measurements", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenAddDialog(false);
      } else {
        setSnackbarMessage("Failed to add Product Quantity. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setOpenAddDialog(false);
      }
    }
  }, [addProductQuantitiesState]);

  useEffect(() => {
    if (editProductQuantitiesState?.success) {
      setSnackbarMessage("Product Quantity updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      reset({
        type_of_alcohol_id: "",
        brand_id: "",
        type_of_quantity: "",
        product_id: "",
        measurements: "",
        wholesaler_id: "",
      });
      setSearchQuery("");
      setOpenEditDialog(false);
      dispatch(productQuantityResetState());
      dispatch(
        productQuantityViewAllRequest(
          getProductQuantityListPayload(
            currentPage,
            productQuantitiesPageSize,
            searchQuery
          )
        )
      );
    } else if (editProductQuantitiesState?.error) {
      const errorFields = editProductQuantitiesState?.errormessage || {};

      if (typeof errorFields === "string") {
        setError("type_of_quantity", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenEditDialog(false);
      } else {
        setSnackbarMessage(
          "Failed to update Product Quantity. Please try again."
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setOpenEditDialog(false);
      }
    }
  }, [editProductQuantitiesState]);

  const handleAddBrand = async (data) => {
    await dispatch(
      productQuantityAddRequest({ ...data, wholesaler_id: WholesalerId })
    );
  };

  const handleEditBrand = async (data) => {
    await dispatch(
      productQuantityEditRequest({
        ...data,
        id: editBrand?.id,
        wholesaler_id: WholesalerId,
      })
    );
  };

  const handleAddCancel = () => {
    reset({
      type_of_alcohol_id: "",
      brand_id: "",
      type_of_quantity: "",
      product_id: "",
      measurements: "",
    });
    setOpenAddDialog(false);
  };

  const handleEditCancel = () => {
    reset({
      type_of_alcohol_id: "",
      brand_id: "",
      type_of_quantity: "",
      product_id: "",
      measurements: "",
      status: "",
    });
    setOpenEditDialog(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={6} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Manage Product Stock</h1>
            <p>Here is the complete list of Manage Product Stock data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handelAddBrand}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>

            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>

      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          {/* <MenuItem
            onClick={() => handleFilterCondition("Sort by Brand Name Asc")}
          >
            Brand Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Brand Name Desc")}
          >
            Brand Name Z-A
          </MenuItem> */}
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Asc")}
          >
            Sub Brand Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Desc")}
          >
            Sub Brand Name Z-A
          </MenuItem>
          <MenuItem
            onClick={() =>
              handleFilterCondition("Sort by Type of Quantity Asc")
            }
          >
            Type Of Quantity A-Z
          </MenuItem>
          <MenuItem
            onClick={() =>
              handleFilterCondition("Sort by Type of Quantity Desc")
            }
          >
            Type Of Quantity Z-A
          </MenuItem>
        </Menu>

        <Paper>
          {/* search */}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by sub-brand name or quantity..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          <Box>
            {viewAllProductQuantitiesState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={viewAllProductQuantitiesState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            )}
            <CustomDataGrid
              rows={rows}
              columns={columns(handleDeleteRow)}
              pageSize={productQuantitiesPageSize}
              pagination={true}
              rowHeight={70}
              onSelectionModelChange={(newSelection) => {
                setSelection(newSelection);
              }}
              sx={filterStyles.modalHeight(rows)}
            />
          </Box>
        </Paper>

        {viewAllProductQuantitiesState?.success && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRecords={totalRecords}
            pageSize={productQuantitiesPageSize}
          />
        )}

        {/* Add Product Quantity Dialog */}
        <Dialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={styles.dialogtitleAddOrEdit}>
            Add Product Quantity Type
          </DialogTitle>
          <DialogContent sx={{ height: "510px", marginTop: "-20px" }}>
            <form onSubmit={handleSubmit(handleAddBrand)}>
              <ReusableFormFields
                inputFields={inputFields(dynamicProductOptions)}
                control={control}
                errors={errors}
                register={register}
                setValue={setValue}
              />
              <DialogActions sx={{ marginBottom: "15px" }}>
                <CustomButton
                  buttonStyle="SubmitButton1"
                  type="submit"
                  disabled={addProductQuantitiesState?.inProgress}
                  loading={addProductQuantitiesState?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleAddCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>

        {/* Edit Product Quantity Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontSize: "20px", fontWeight: "bold" }}>
            Modify Product Quantity Type
          </DialogTitle>
          <DialogContent sx={{ height: "550px", marginTop: "-20px" }}>
            <form onSubmit={handleSubmit(handleEditBrand)}>
              <ReusableFormFields
                inputFields={inputField(
                  dynamicProductOptions,
                  editBrand?.type_of_alcohol_id,
                  editBrand?.brand_id,
                  editBrand?.product_id,
                  editBrand?.wholesaler_id,
                  editBrand?.type_of_quantity
                )}
                control={control}
                errors={errors}
                register={register}
                setValue={setValue}
              />
              <DialogActions sx={{ marginBottom: "15px" }}>
                <CustomButton
                  buttonStyle="SubmitButton"
                  type="submit"
                  disabled={editProductQuantitiesState?.inProgress}
                  loading={addProductQuantitiesState?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleEditCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
        {/* Snackbar */}
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};

export default ProductQuantity;
